import { uploadImgApi } from '@/config/axios/new_api'
import http from '@/config/axios/index'
Date.prototype.Format = function (fmt) {
  var o = {
    'M+': this.getMonth() + 1, //月份
    'd+': this.getDate(), //日
    'h+': this.getHours(), //小时
    'm+': this.getMinutes(), //分
    's+': this.getSeconds(), //秒
    'q+': Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  for (let k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
  return fmt
}
/**
 *
 * @param {Array} data 需要扁平化的数组
 * @param {String} keys 需要扁平化的关键字
 * 目前这一块主要运用在路由判断权限， 如果有其他操作， 请进行确认
 */
const flatData = (data, keys) => {
  return data.reduce((acc, next) => {
    acc.push(next)
    if (next[keys] && next[keys].length) acc.push(...flatData(next[keys]))
    return acc
  }, [])
}

export default {
  /*
   ** 用途：检查输入手机号码是否正确
   ** 输入：strMobile：字符串
   ** 返回：如果通过验证返回true,否则返回false
   */
  checkMobile: function (strMobile) {
    var regu = /^[1][1-9][0-9]{9}$/
    var re = new RegExp(regu)
    if (re.test(strMobile)) {
      return true
    } else {
      return false
    }
  },
  emailRegExp: function () {
    // -_.不能连续  不能以_-.结尾
    // return /^[A-Za-z0-9]([A-Za-z0-9]*[-_\.]?[A-Za-z0-9]+)*@[a-zA-Z\d]+\.[a-zA-Z]{1,5}$/
    //-_.不能连续， 可以以-_.开头和结尾
    return /^([A-Za-z0-9]*[-_\.]?[A-Za-z0-9]+)*[A-Za-z0-9\._-]@[a-zA-Z\d]+\.[a-zA-Z]{1,5}$/
  },
  setCookie(key, v) {
    let d = new Date()
    // 目前设置10分钟
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000)
    // let domain = "";
    // // if (process.env.NODE_ENV === "production") {
    // //   domain = `domain= wxbjq.top`;
    // // }
    document.cookie = `${key}=${v};expires=${d.toGMTString()};path=/;`
  },
  removeCookie(key) {
    let d = new Date(),
      v = this.getCookie(key)
    d.setTime(d.getTime() - 1000)
    if (v !== undefined) {
      this.setCookie(key, '', d)
    }
  },
  getCookie(key) {
    let arr,
      result,
      reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
    if ((arr = document.cookie.match(reg))) {
      result = arr[2]
    }
    return result
  },
  /**
   *
   * @param date
   * @param str
   * @returns {string}
   */
  getDate(date, str = '-') {
    let newD = new Date(date)
    let year = newD.getFullYear()
    let month =
      newD.getMonth() + 1 >= 10
        ? newD.getMonth() + 1
        : `0${newD.getMonth() + 1}`
    let day = newD.getDate() >= 10 ? newD.getDate() : `0${newD.getDate()}`
    return `${year + str + month + str + day}`
  },
  getMin(date) {
    if (!date) {
      return '-'
    }
    return new Date(date).Format('yyyy-MM-dd hh:mm')
  },
  getSec(date) {
    if (!date) {
      return '-'
    }
    return new Date(date).Format('yyyy-MM-dd hh:mm:ss')
  },
  getMMddhhmm(date) {
    if (!date) {
      return '-'
    }
    return new Date(date).Format('MM-dd hh:mm')
  },
  getddhhmm(date) {
    if (!date) {
      return '-'
    }
    let nowDate = new Date().getTime()
    let newDate = new Date(
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    ).getTime()
    let sixHours = 6 * 60 * 60 * 1000
    date = date + newDate - nowDate + sixHours
    date = Number(date.toFixed(0))
    let Dates = new Date(date)
    let hours = Dates.getHours()
    let min = Dates.getMinutes()
    return `${hours}时${min}分`
  },
  /**
   * 对日期格式（20191210）进行格式化
   */
  dayFormat(str) {
    if (parseInt(str)) {
      return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6)}`
    }
    return str
  },

  downloadImg(imgSrc, name) {
    var dotIndex = imgSrc.lastIndexOf('.') + 1
    var fileTypeStr = imgSrc.slice(dotIndex)

    var image = new Image()
    // 解决跨域 Canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous')
    image.onload = function () {
      var canvas = document.createElement('canvas')
      canvas.width = image.width
      canvas.height = image.height
      var context = canvas.getContext('2d')
      context.drawImage(image, 0, 0, image.width, image.height)
      var url = canvas.toDataURL(`image/${fileTypeStr}`) //得到图片的base64编码数据

      var a = document.createElement('a') // 生成一个a元素
      var event = new MouseEvent('click') // 创建一个单击事件
      a.download = `${name}.${fileTypeStr}` || `photo.${fileTypeStr}` // 设置图片名称
      a.href = url // 将生成的URL设置为a.href属性
      a.dispatchEvent(event) // 触发a的单击事件
    }
    image.src = imgSrc
  },
  async downloadFile(url, fileName = '') {
    try {
      let blob = await downloadBlob(url, fileName)
      let newurl = URL.createObjectURL(blob)
      downloadURL(newurl, fileName)
      URL.revokeObjectURL(newurl)
    } catch (err) {
      throw new Error(err.message)
    }
    function downloadBlob(url) {
      return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest()
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        xhr.onload = function () {
          if (xhr.status === 200) {
            resolve(xhr.response)
          } else {
            reject(new Error(xhr.statusText || 'Download failed.'))
          }
        }
        xhr.onerror = function () {
          reject(new Error('Download failed.'))
        }
        xhr.send()
      })
    }
    function downloadURL(url, name = '') {
      let link = document.createElement('a')
      link.download = name
      link.href = url
      if ('download' in document.createElement('a')) {
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        // 对不支持download进行兼容
        click(link, (link.target = '_blank'))
      }
    }
    function click(node) {
      try {
        node.dispatchEvent(new MouseEvent('click'))
      } catch (e) {
        var evt = document.createEvent('MouseEvents')
        evt.initMouseEvent(
          'click',
          true,
          true,
          window,
          0,
          0,
          0,
          80,
          20,
          false,
          false,
          false,
          false,
          0,
          null
        )
        node.dispatchEvent(evt)
      }
    }
  },

  // 防抖
  debounce(func, threshold, execAsap) {
    var timeout
    return function debounced() {
      var obj = this,
        args = arguments
      function delayed() {
        if (!execAsap) func.apply(obj, args)
        timeout = null
      }
      if (timeout) {
        clearTimeout(timeout)
      } else if (execAsap) {
        func.apply(obj, args)
      }
      timeout = setTimeout(delayed, threshold || 100)
    }
  },
  /**
   * 跳转链接 主要用于封装跳转
   * @param {string} href
   */
  toHref(href) {
    /* let domininfo = href.split(".wxbjq.top");

    href = domininfo[0] + ".mff.wxbjq.top"; */

    window.location.href = href
  },
  flatData,
  GetQueryString: function (name) {
    var result = ''
    var searchStr = window.location.search.substr(1)
    if (!searchStr || searchStr === '') {
      return null
    }

    var searchs = searchStr.split('&')
    var querys = {}
    for (var i = searchs.length - 1; i >= 0; i--) {
      querys[searchs[i].split('=')[0]] = searchs[i].split('=')[1]
    }

    if (querys[name] && querys[name] !== '' && querys[name] !== 'null') {
      result = querys[name]
    }

    return result
  },
  /**
   * 图片上传
   * @param {*} params  {file：文件, format: '图片格式', upload_type: '上传类型'}
   * @param {*} callback 回调函数 ({status: 0, url: '', message: '错误信息'}) => {}
   */
  qyUploadImg: function (params, callback) {
    uploadImgApi({
      upload_type: params.upload_type,
      format: params.format
    }).then((res) => {
      if (res.status === 1) {
        let { data } = res
        let formData = new FormData() // FormData 对象
        formData.append('success_action_status', 200)
        formData.append('key', data.dir) // 上传地址+ 名称    从token接口返回
        formData.append('policy', data.policy)
        formData.append('OSSAccessKeyId', data.accessid)
        formData.append('callback', data.callback)
        formData.append('signature', data.signature)
        formData.append('file', params.file) // 文件对象
        http
          .httpServer({
            url: data.host,
            method: 'POST',
            data: formData
          })
          .then((response) => {
            let url = ''
            if (response.status === 1) {
              let { host, filename } = response.data
              url = host + '/' + filename
            }
            var getType = {}
            if (
              callback &&
              getType.toString.call(callback) === '[object Function]'
            ) {
              callback({
                status: response.status,
                url: url,
                message: response.message,
                data: response.data
              })
            }
          })
      }
    })
  },
  /**
   * 瀑布流方法
   */
  waterFall(list) {
    // 页面的宽度
    let screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    let pageWidth = screenWidth - 220 // 容器宽度
    let gap = 20 // 间距
    let itemWidth = 200 // 初始item宽度
    let int = pageWidth / (itemWidth + gap) // 根据容器宽度计算列
    let columns = parseInt(int) > 3 ? parseInt(int) : 3 // 最少列数
    let arr = [] //定义一个数组，用来存储元素的定位信息
    let data = JSON.parse(JSON.stringify(list)) // 深拷贝
    let surplus_width = pageWidth - ((itemWidth + gap) * columns + 20) // 容器多余宽度
    let item_surplus_width = surplus_width / columns // 每列平均分配多余的宽度
    let maxTop = 0 // 最大高度
    let containerHeight = 'calc(100% - 380px)'
    data.forEach((item, index) => {
      item.new_width = itemWidth + item_surplus_width
      item.new_height = item.height / (item.width / item.new_width)
      // 小于当前总列数top值为0
      if (index < columns) {
        item.top = 0
        // left值为当前宽度加间距乘以下标加上外层容器左侧的20间距
        item.left = (item.new_width + gap) * index + 20
        arr.push({
          left: item.left,
          top: item.new_height + gap
        })
      } else {
        // 定义最小top值，默认为arr第一项
        let minTop = arr[0].top
        // 初始下标记录
        let index = 0
        arr.forEach((sub, ind) => {
          // 替换信息
          if (minTop > sub.top) {
            minTop = sub.top
            index = ind
          }
        })
        item.top = minTop
        item.left = arr[index].left
        arr[index] = {
          left: item.left,
          // 每次定位完成之后加上当前最小top值
          top: item.height / (item.width / item.new_width) + gap + minTop
        }
      }
      arr.forEach((val) => {
        if (val.top > maxTop) {
          maxTop = val.top
          containerHeight = maxTop + 'px' // 设置容器高度
        }
      })
    })
    return {
      data,
      containerHeight
    }
  },

  
}
